// ...existing code...
import React, { useState, useRef, useEffect } from 'react';

const SearchBox = (props: any) => {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const searchBoxRef = useRef<any>(null);

    const onPlacesChanged = () => {
        try {
            const searchBox = searchBoxRef.current;
            if (!searchBox) return;
            const selected = searchBox.getPlaces();
            const place = selected && selected[0];
            if (!place || !place.geometry) return;

            if (place.geometry.viewport && props.map && props.map.fitBounds) {
                props.map.fitBounds(place.geometry.viewport);
            } else if (place.geometry.location && props.map && props.map.setCenter) {
                props.map.setCenter(place.geometry.location);
                props.map.setZoom?.(17);
            }

            if (props.addplace) props.addplace(place);

            if (inputRef.current) {
                inputRef.current.blur();
                inputRef.current.value = '';
            }
        } catch (err) {
            // ignore
        }
    };

    // Search button: use PlacesService.textSearch to find a place by query (fallback when user clicks search)
    const handleSearchClick = () => {
        try {
            const q = inputRef.current?.value?.trim();
            if (!q || !props.mapApi || !props.map) return;
            const service = new props.mapApi.places.PlacesService(props.map);
            service.textSearch({ query: q }, (results: any, status: any) => {
                const okStatus = props.mapApi.places.PlacesServiceStatus?.OK ?? 'OK';
                if (status === okStatus && results && results[0]) {
                    const place = results[0];
                    if (place.geometry?.viewport && props.map?.fitBounds) {
                        props.map.fitBounds(place.geometry.viewport);
                    } else if (place.geometry?.location && props.map?.setCenter) {
                        props.map.setCenter(place.geometry.location);
                        props.map.setZoom?.(17);
                    }
                    if (props.addplace) props.addplace(place);
                    if (inputRef.current) {
                        inputRef.current.blur();
                        inputRef.current.value = '';
                    }
                }
            });
        } catch (e) {
            // ignore
        }
    };

    const handleClearClick = () => {
        if (inputRef.current) {
            inputRef.current.value = '';
            inputRef.current.focus();
        }
    };

    useEffect(() => {
        const input = inputRef.current;
        if (!input || !props.mapApi || !props.map) return;

        try {
            searchBoxRef.current = new props.mapApi.places.SearchBox(input);
            searchBoxRef.current.addListener('places_changed', onPlacesChanged);
            searchBoxRef.current.bindTo('bounds', props.map);
        } catch (e) {
            // ignore
        }

        return () => {
            try {
                props.mapApi.event.clearInstanceListeners(searchBoxRef.current);
            } catch (e) {
                /* ignore */
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.mapApi, props.map]);

    return (
        <div className="input-group" style={{ padding: "1rem 1rem 0 1rem" }}>
            <input
                className="form-control"
                ref={inputRef}
                placeholder="กรอกชื่อสถานที่"
                type="text"
                autoComplete="off"
            />
            <button type="button" className="btn btn-outline-secondary" onClick={handleSearchClick} title="ค้นหา">
                <i className="fa fa-search" />
            </button>
            {/* <button type="button" className="btn btn-outline-secondary" onClick={handleClearClick} title="ล้างข้อความ">
        <i className="fa fa-times" />
      </button> */}
        </div>
    );
};

const Marker = (props: any) => {
    const [marker, setMarker] = useState<any>(null);

    useEffect(() => {
        if (!marker && props.map && props.mapApi) {
            const MarkerCtor =
                (props.mapApi && props.mapApi.Marker) || (window as any).google?.maps?.Marker;
            if (MarkerCtor) {
                const m = new MarkerCtor();
                setMarker(m);
            }
        }

        return () => {
            if (marker) {
                marker.setMap(null);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.map, props.mapApi]);

    useEffect(() => {
        if (marker && props.map) {
            marker.setOptions({ position: props.position, map: props.map });
        }
    }, [marker, props.position, props.map]);

    return null;
};

const SelectedBox = (props: any) => {
    return (
        <div>
            {props.selected
                ?.filter((el: any) => el.selected === true)
                .map((e: any, i: number) => (
                    <div className="col-md-12 mb-2" key={i}>
                        <div className="input-group">
                            {/* <div className="input-group-prepend">
                <span className="input-group-text">{e.label}</span>
              </div> */}
                            {/* <input
                disabled={props.isDisabled}
                type="number"
                className="form-control"
                value={e.amount}
                onChange={(ev) => {
                  if (props.onValueChange) props.onValueChange(e.value, ev.target.value);
                }}
              /> */}
                            {/* <div className="input-group-append">
                <span className="input-group-text">{e.unit}</span>
              </div> */}
                        </div>
                    </div>
                ))}
        </div>
    );
};

export { Marker, SearchBox, SelectedBox };
// ...existing code...